import { CirclePacking } from '../../models/circlePackingModel';

export const getRelativesSelected: (circle: CirclePacking, model: Array<string>, modelProperty: string) => Array<string> = (
  circle,
  model,
  modelProperty
) => {
  const ancestors = circle.ancestors.map((d) => d[modelProperty]);
  const descendants = findDescendants(circle).map((d) => d[modelProperty]);

  return (model || []).filter((d) => [...ancestors, ...descendants].indexOf(d) !== -1);
};

export const findDescendants = (node: any) => {
  const nodeDescendants = (node.children || []).reduce(
    (allDescendants, child) => allDescendants.concat([child]).concat(findDescendants(child)),
    []
  );
  return nodeDescendants;
};
